<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg-icon class-name="international-icon" icon-class="language" class='icon'/>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh">
        中文
      </el-dropdown-item>
      <el-dropdown-item command="en">
        English
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  computed: {
    language () {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage (lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
    }
  }
}
</script>
<style lang="scss" scope>
.icon {
  font-size: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/LangSelect/index.vue